import { createSelector } from 'reselect';

const getFiles = (state) => (state.data ? state.data.files : state.files) || {};
const getFileScanByS3Key = (state) =>
  (state.data ? state.data.fileScanByS3Key : state.fileScanByS3Key) || {};

export const getFileScanStatus = createSelector(
  [getFiles, getFileScanByS3Key],
  (files, directMap) => {
    // byId: Parse/DB file record id → status (for files that have been resolved by ID)
    const byId = Object.entries(files).reduce((acc, [id, file]) => {
      if (file?.scanStatus != null) {
        acc[id] = file.scanStatus;
      }
      return acc;
    }, {});

    // directMap: decoded s3Key → status (primary lookup used by the editor)
    return {
      ...byId,
      ...directMap,
    };
  }
);
